<template>
  <div class="post d-flex flex-column-fluid pt-7 bg-lighten">
    <div class="container-xxl p-0" ref="errosGerais">
      <div
        v-if="loading"
        class="ms-7 mb-7"
        v-bind:data-kt-indicator="loading ? 'on' : 'off'"
      >
        <span class="indicator-progress">
          Aguarde, carregando...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </div>
      <div
        v-if="this.errosGerais.Message"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-7 me-7 mb-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              {{ this.errosGerais.Message }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="d-flex flex-column flex-lg-row px-7">
        <div class="d-flex flex-column gap-6 gap-lg-10 mb-7 w-100 w-lg-300px">
          <div class="card card-flush py-4 me-lg-10">
            <div class="card-header">
              <div class="card-title">
                <h2>Imagem</h2>
              </div>
            </div>
            <div class="card-body text-center">
              <div
                id="imgImagem"
                class="image-input image-input-outline"
                data-kt-image-input="true"
              >
                <div
                  class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                  v-if="adicionalGrupoItem.imagem"
                  :style="{
                    'background-image': `url(${adicionalGrupoItem.imagem})`,
                  }"
                ></div>
                <div
                  class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                  v-else
                  :style="{
                    'background-image': `url(media/svg/files/blank-image.svg)`,
                  }"
                ></div>
                <label
                  class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                  data-kt-image-input-action="change"
                  data-bs-toggle="tooltip"
                  data-bs-dismiss="click"
                  title="Alterar imagem"
                >
                  <i class="bi bi-pencil-fill fs-7"></i>
                  <input
                    ref="fileInput"
                    type="file"
                    name="avatar"
                    accept=".png, .jpg, .jpeg"
                    @input="pickFile"
                  />
                  <input type="hidden" name="avatar_remove" />
                </label>
                <span
                  class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                  data-kt-image-input-action="remove"
                  data-bs-toggle="tooltip"
                  @click="removerImagem()"
                  data-bs-dismiss="click"
                  title="Remover imagem"
                >
                  <i class="bi bi-x fs-2"></i>
                </span>
              </div>
              <div class="form-text mt-6">
                Selecione a imagem do item de adicional. Apenas *.png, *.jpg e
                *.jpeg aquivos de imagem são aceitos
              </div>
            </div>
          </div>
          <div class="card card-flush py-4 me-lg-10">
            <div class="card-header">
              <div class="card-title">
                <h2>Situação</h2>
              </div>
            </div>
            <div class="card-body text-center pt-0">
              <select class="form-select" v-model="adicionalGrupoItem.ativo">
                <option value="1">Ativo</option>
                <option value="0">Indisponível</option>
              </select>
              <div class="text-end text-muted fs-7">
                Defina a situação do item de adicional.
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10">
          <div class="d-flex flex-column gap-7 gap-lg-10">
            <div class="card card-flush py-4">
              <div class="card-header">
                <div class="card-title">
                  <h2>Geral</h2>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="mb-5 fv-row">
                  <label class="required form-label"
                    >Descrição do item de adicional</label
                  >
                  <input
                    id="txtDescricao"
                    type="text"
                    class="form-control mb-2"
                    placeholder="Descrição do item de adicional"
                    maxlength="75"
                    v-model="adicionalGrupoItem.descricao"
                  />
                  <div class="row">
                    <div class="col-6 pe-0">
                      <div
                        class="fv-plugins-message-container invalid-feedback m-0"
                      >
                        {{ errosValidacao["descricao"] }}
                      </div>
                    </div>
                    <div class="col-6 ps-2">
                      <div class="text-end text-muted fs-7">
                        {{ adicionalGrupoItem.descricao.length }}/75 caracteres
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-5 fv-row">
                  <label class="form-label">Código PDV (SKU)</label>
                  <input
                    id="txtReferencia"
                    type="text"
                    class="form-control mb-2"
                    placeholder="Código PDV (SKU)"
                    v-model="adicionalGrupoItem.cod_referencia"
                  />
                  <div class="row">
                    <div class="col-6 pe-0">
                      <div
                        class="fv-plugins-message-container invalid-feedback m-0"
                      >
                        {{ errosValidacao["cod_referencia"] }}
                      </div>
                    </div>
                    <div class="col-6 ps-2">
                      <div class="text-end text-muted fs-7">
                        O código PDV é o código de referencia da sua aplicação.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column gap-7 gap-lg-10">
            <div class="card card-flush py-4">
              <div class="card-header">
                <div class="card-title">
                  <h2>Definição de Preço</h2>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="mb-5 fv-row">
                  <label class="form-label required">Preço</label>
                  <CurrencyInput
                    class="form-control mb-2"
                    placeholder="Preço do item de adicional"
                    style="text-align: right"
                    v-model="adicionalGrupoItem.valor"
                    :options="options"
                  ></CurrencyInput>
                  <div class="row">
                    <div class="col-6 pe-0">
                      <div
                        class="fv-plugins-message-container invalid-feedback m-0"
                      >
                        {{ errosValidacao["valor"] }}
                      </div>
                    </div>
                    <div class="col-6 ps-2">
                      <div class="text-end text-muted fs-7">
                        Informe o valor do item de adicional
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end py-6 px-9">
        <button
          data-bs-dismiss="modal"
          class="btn btn-danger svg-icon-white me-2 mb-2"
          @click="$emit('cancelarAdicionalGrupoItem', false)"
        >
          <span class="svg-icon svg-icon-1">
            <inline-svg
              src="media/icons/duotune/arrows/arr015.svg"
              class="me-2"
            />Cancelar
          </span>
        </button>
        <button
          class="btn btn-success svg-icon-white mb-2"
          @click="confirmarAdicionalGrupoItem()"
          v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
        >
          <span class="indicator-progress">
            <span
              class="spinner-border spinner-border-sm align-middle ms-1"
            ></span>
            Aguarde...
          </span>
          <span class="svg-icon svg-icon-1" v-if="!this.loading">
            <inline-svg
              src="media/icons/duotune/arrows/arr016.svg"
              class="me-2"
            />Confirmar
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CurrencyInput from "@/components/text/CurrencyInput";

export default {
  emits: ["cancelarAdicionalGrupoItem", "confirmarAdicionalGrupoItem"],
  components: { CurrencyInput },
  props: {
    idAdicionalGrupo: { type: Number, required: true },
    idAdicionalGrupoItem: { type: Number, required: true },
  },
  methods: {
    async confirmarAdicionalGrupoItem() {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.loading = true;

      this.adicionalGrupoItem.imagem =
        this.adicionalGrupoItem.imagem === null
          ? ""
          : this.adicionalGrupoItem.imagem.replace(this.$utils.getUrl(), "");
      this.adicionalGrupoItem.cod_referencia =
        this.adicionalGrupoItem.cod_referencia === null
          ? ""
          : this.adicionalGrupoItem.cod_referencia;

      if (this.adicionalGrupoItem.id === 0) {
        this.adicionalGrupoItem.id_adicional_grupo = this.idAdicionalGrupo;
        this.adicionalGrupoItem.guid = this.$utils.generateUuidv4();
      }

      if (this.adicionalGrupoItem.id === 0) {
        try {
          var ret = await this.$store.dispatch(
            "adicionalGrupoItem/getAdicionalGrupoItemOData",
            "?$select=ordem&$orderby=ordem desc&$top=1&$filter=id_adicional_grupo eq " +
              this.idAdicionalGrupo
          );
          if (ret.value !== null && ret.value.length > 0) {
            this.adicionalGrupoItem.ordem = ret.value[0].ordem + 1;
          } else {
            this.adicionalGrupoItem.ordem = 1;
          }
          await this.cadastrarAdicionalGrupoItem();
        } catch (error) {
          this.errosGerais = error;
        }
      } else {
        var formData = this.$utils.convertModelToFormData(
          this.adicionalGrupoItem
        );
        try {
          var retPut = await this.$store.dispatch(
            "adicionalGrupoItem/putAdicionalGrupoItem",
            formData
          );
          if (retPut.Success === true) {
            this.$emit("confirmarAdicionalGrupoItem");
          }
        } catch (error) {
          this.errosGerais = error;
          this.errosValidacao = error;
        }
      }

      if (
        this.adicionalGrupoItem.imagem !== "" &&
        !this.adicionalGrupoItem.imagem.includes("base64")
      ) {
        this.adicionalGrupoItem.imagem =
          this.$utils.getUrl() + this.adicionalGrupoItem.imagem;
      }

      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }
      this.loading = false;
    },
    async cadastrarAdicionalGrupoItem() {
      var formData = this.$utils.convertModelToFormData(
        this.adicionalGrupoItem
      );
      try {
        var retPost = await this.$store.dispatch(
          "adicionalGrupoItem/postAdicionalGrupoItem",
          formData
        );
        if (retPost.Success === true) {
          this.$emit("confirmarAdicionalGrupoItem");
        }
      } catch (error) {
        this.errosGerais = error;
        this.errosValidacao = error;
      }
    },
    limparAdicionalGrupoItem() {
      this.adicionalGrupoItem = {
        id: 0,
        id_adicional_grupo: 0,
        descricao: "",
        valor: 0,
        ativo: "1",
        guid: "",
        cod_referencia: "",
        imagem: "",
        ordem: 0,
        formFile: null,
        imagemRemover: "",
      };

      this.errosGerais = {};
      this.errosValidacao = [];
    },
    removerImagem() {
      if (this.add === true) {
        this.adicionalGrupoItem.imagemRemover = "";
      } else {
        this.adicionalGrupoItem.imagemRemover =
          this.adicionalGrupoItem.imagem.replace(this.$utils.getUrl(), "");
      }
      this.adicionalGrupoItem.imagem = "";
      this.adicionalGrupoItem.formFile = null;
      this.$refs.fileInput.value = null;
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          if (this.adicionalGrupoItem.imagem !== null) {
            this.adicionalGrupoItem.imagemRemover =
              this.adicionalGrupoItem.imagem.replace(this.$utils.getUrl(), "");
          }

          this.adicionalGrupoItem.imagem = e.target.result;
          this.adicionalGrupoItem.formFile = file[0];
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async carregarAdicionalGrupoItem() {
      this.errosGerais = {};
      this.errosValidacao = [];
      try {
        var ret = await this.$store.dispatch(
          "adicionalGrupoItem/getAdicionalGrupoItem",
          this.idAdicionalGrupoItem
        );
        if (ret.Success === true) {
          if (ret.Data !== null) {
            this.adicionalGrupoItem = ret.Data;

            if (
              this.adicionalGrupoItem.imagem !== null &&
              this.adicionalGrupoItem.imagem !== ""
            ) {
              this.adicionalGrupoItem.imagem =
                this.$utils.getUrl() + this.adicionalGrupoItem.imagem;
            }
          } else {
            this.errosGerais = ret;
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }
      this.loading = false;
    },
    async asyncData() {
      if (this.idAdicionalGrupoItem !== 0) {
        this.loading = true;
        this.add = false;
        await this.carregarAdicionalGrupoItem();
      } else {
        this.add = true;
        this.limparAdicionalGrupoItem();
      }
    },
  },
  mounted() {
    this.asyncData();
  },
  data() {
    return {
      loading: false,
      add: false,
      errosGerais: {},
      errosValidacao: [],
      adicionalGrupoItem: {
        id: 0,
        id_adicional_grupo: 0,
        descricao: "",
        valor: 0,
        ativo: "1",
        guid: "",
        cod_referencia: "",
        imagem: "",
        ordem: 0,
        formFile: null,
        imagemRemover: "",
      },
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style>
.imagePreviewWrapper {
  background-size: contain !important;
  background-position: center !important;
}
</style>
